import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Helper function to extract YouTube video ID
function getYouTubeVideoId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
}
export function ExperienceInfo(t0) {
  const $ = _c(18);
  const {
    experience
  } = t0;
  if (!experience) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      a: _temp,
      code: _temp2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const markdownComponents = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(Button, {
      className: "mt-4 inline-flex items-center gap-2",
      variant: "ghost",
      asChild: true,
      children: /*#__PURE__*/_jsxs(Link, {
        to: "/upplevelser",
        className: "inline-flex items-center gap-1",
        children: [/*#__PURE__*/_jsx(ArrowLeft, {
          className: "h-4 w-4"
        }), " Tillbaka"]
      })
    });
    t3 = cn("prose prose-gray dark:prose-invert lg:prose-xl", "mx-auto mt-8");
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== experience.title) {
    t4 = /*#__PURE__*/_jsx("h1", {
      className: "text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl",
      children: experience.title
    });
    $[3] = experience.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== experience) {
    t5 = experience.experienceCategories?.map(_temp3);
    $[5] = experience;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: "not-prose my-6 flex flex-wrap gap-2",
      children: t5
    });
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== experience.subtitle) {
    t7 = experience.subtitle && /*#__PURE__*/_jsx("p", {
      className: "text-lg text-muted-foreground",
      children: experience.subtitle
    });
    $[9] = experience.subtitle;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== experience.description) {
    t8 = experience.description && /*#__PURE__*/_jsx("div", {
      className: cn("prose prose-lg prose-gray dark:prose-invert", "mt-8", "prose-headings:font-bold prose-headings:tracking-tight", "prose-p:leading-relaxed", "prose-a:text-primary prose-a:no-underline hover:prose-a:underline", "prose-strong:font-semibold", "prose-ul:list-disc prose-ol:list-decimal", "prose-blockquote:border-l-4 prose-blockquote:border-muted prose-blockquote:bg-muted/5", "prose-blockquote:pl-6 prose-blockquote:py-2 prose-blockquote:italic", "prose-blockquote:text-muted-foreground dark:prose-blockquote:text-muted-foreground", "prose-blockquote:font-normal prose-blockquote:not-italic", "prose-blockquote:rounded-r-lg", "prose-img:rounded-lg prose-img:shadow-md", "prose-code:text-primary prose-code:bg-primary/5 prose-code:rounded prose-code:px-1 prose-code:py-0.5", "prose-pre:bg-zinc-950 prose-pre:text-zinc-50 prose-pre:shadow-lg"),
      children: /*#__PURE__*/_jsx(ReactMarkdown, {
        components: markdownComponents,
        children: experience.description
      })
    });
    $[11] = experience.description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-4xl px-4 py-12 md:px-6 lg:py-16",
      children: [t2, /*#__PURE__*/_jsxs("article", {
        className: t3,
        children: [t4, t6, t7, t8]
      })]
    });
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp3(ec) {
  return ec.category && /*#__PURE__*/_jsx("span", {
    className: "inline-flex items-center rounded-full bg-secondary px-3 py-1 text-sm font-medium",
    children: ec.category.name
  }, ec.category.id);
}
function _temp2(t0) {
  const {
    inline,
    className,
    children: children_0,
    ...props_0
  } = t0;
  const match = /language-(\w+)/.exec(className || "");
  return /*#__PURE__*/_jsx("code", {
    className: cn(!inline && "block p-4", match && `language-${match[1]}`, className),
    ...props_0,
    children: children_0
  });
}
function _temp(t0) {
  const {
    href,
    children,
    ...props
  } = t0;
  if (!href) {
    return /*#__PURE__*/_jsx("span", {
      children: children
    });
  }
  const videoId = getYouTubeVideoId(href);
  if (videoId) {
    return /*#__PURE__*/_jsx("div", {
      className: "relative aspect-video w-full overflow-hidden rounded-lg",
      children: /*#__PURE__*/_jsx("iframe", {
        src: `https://www.youtube.com/embed/${videoId}`,
        title: "YouTube video",
        className: "absolute inset-0 h-full w-full border-0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      })
    });
  }
  return /*#__PURE__*/_jsx("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: href,
    ...props,
    children: children
  });
}